var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"board-bg"},[_c('div',{staticClass:"board-bg__overlay position-absolute",style:(`background-image: url(${require('../assets/images/bg-0.jpg')})`)}),_c('div',{staticClass:"board-bg__gradient board-bg__gradient--peephole board-bg__gradient--filtered"}),_c('div',{staticClass:"board-bg__content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }